// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import LdapUserModal from '../../modals/ldap_user_modal'

up.compiler('.ldap-user-select', (element, data) => {
  up.on(element, 'click', '.ldap-user-select--search', function(e) {
    e.preventDefault()

    const userIdInputSelector = data.user_id_input_selector
    const userIdInput = element.querySelector(userIdInputSelector)

    const ldapUserModal = new LdapUserModal({ only_ldap: false, createLdapUsers: true })
    ldapUserModal.open().then((user) => {
      if (!user) { return }

      userIdInput.value = user.id

      up.emit(userIdInput, 'change')
    })
  })
})
